import React, {useEffect} from 'react';
import styles from './Contacto.module.css'; // Importa los estilos
import emilioHD from './images/emiliOHD.webp';
import kevinHD from './images/kevinCuadrado.webp';
import backgroundVideo from './images/background3.mp4'; // Asegúrate de ajustar la ruta del video
import { FaInstagram} from "@react-icons/all-files/fa/FaInstagram";
import { FaWhatsapp } from "@react-icons/all-files/fa/FaWhatsapp";
import { MdOutlineEmail } from "react-icons/md";
import { FaCircle } from "react-icons/fa";
import Footer from '../Home/Footer/Footer';

export const S5 = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <div className={styles.container}>
                <div className={styles.videoBackground}>
                    <video autoPlay loop muted playsInline className={styles.videoElement}>
                        <source src={backgroundVideo} type="video/mp4" />
                        Tu navegador no soporta el video.
                    </video>
                </div>
                <div className={styles.TituloSeccion}>
                    Contáctate con <span>Nosotros</span>
                </div>
                <div className={styles.movingDots}>
                    <FaCircle className={styles.dot1} />
                    <FaCircle className={styles.dot2} />
                    <FaCircle className={styles.dot3} />
                </div>
                <div className={styles.section}>
                    <div className={styles.card}>
                        <div className={styles.cardContent}>
                            <div className={styles.cardFront}>
                                <div className={styles.blueBorder}></div> 
                                <img src={emilioHD} alt="Emilio Rosado" />
                                <h2>Emilio Rosado</h2>
                                <h3>CEO Relatividad IA</h3>
                                <div className={styles.socialMedia}> 
                                    <FaInstagram className={styles.icon1} onClick={() => window.location.href = 'https://www.instagram.com/emilioj.rosado/'}/>
                                    <FaWhatsapp className={styles.icon2} onClick={() => window.location.href = 'https://wa.me/593992722256'} />
                                    <MdOutlineEmail className={styles.icon3} onClick={() => window.location.href = 'mailto:emilio@relatividadia.com'}/>
                                    <div className={styles.blueLine}></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.card}>
                        <div className={styles.cardContent}>
                            <div className={styles.cardFront}>
                                <img src={kevinHD} alt="Kevin Rojas" />
                                <h2>Kevin Rojas</h2>
                                <h3>CTO Relatividad IA</h3>
                                <div className={styles.socialMedia}> 
                                    <FaInstagram className={styles.icon1} onClick={() => window.location.href = 'https://www.instagram.com/kevojas/'}/>
                                    <FaWhatsapp className={styles.icon2} onClick={() => window.location.href = 'https://api.whatsapp.com/send?phone=593995772424'} />
                                    <MdOutlineEmail className={styles.icon3} onClick={() => window.location.href = 'mailto:kevin@relatividadia.com'}/>
                                    <div className={styles.blueLine}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>

    );
}

export default S5;
